import { useEffect, useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import ArtworkTerms from './ArtworkTerms';

export default function ArtworkAgreementCheckboxes({
  formError,
  setFormError,
  termsAccepted,
  setTermsAccepted,
  isAuctionAccount = false,
  auctionAgreementAccepted,
  setAuctionAgreementAccepted,
}) {
  const t = useTranslations('common.forms.add_artwork');
  const [openArtworkTerms, setOpenArtworkTerms] = useState(false);

  useEffect(() => {
    setFormError(prevErrors => {
      if (!Array.isArray(prevErrors)) {
        return prevErrors === null ? [] : prevErrors;
      }

      return prevErrors.filter(error => {
        if (termsAccepted && error.element === 'artwork_terms') return false;
        if (auctionAgreementAccepted && error.element === 'artwork_auction_terms') return false;
        return true;
      });
    });
  }, [termsAccepted, auctionAgreementAccepted, setFormError]);

  return (
    <>
      <PublicFormInput
        element="artwork_terms"
        type="checkbox"
        error={Array.isArray(formError) ? formError.find(error => error.element === 'artwork_terms') : null}
        value={termsAccepted}
        onChange={(value) => {
          setTermsAccepted(value);
          if (value) {
            setFormError(prevErrors => (
              prevErrors ? prevErrors.filter(error => error.element !== 'artwork_terms') : []
            ));
          }
        }}
      >
        {t('checkboxes.accept_prefix')}{t('checkboxes.accept_separator')}
        <span className="submit-button-artwork-terms-opener" onClick={() => setOpenArtworkTerms(true)}>
          Artwork Agreement
        </span>{t('checkboxes.accept_suffix') && ` ${t('checkboxes.accept_suffix')}`}.
      </PublicFormInput>

      {isAuctionAccount && (
        <PublicFormInput
          element="artwork_auction_terms"
          type="checkbox"
          error={Array.isArray(formError) ? formError.find(error => error.element === 'artwork_auction_terms') : null}
          value={auctionAgreementAccepted}
          onChange={setAuctionAgreementAccepted}
        >
          {t('checkboxes.accept_prefix')}{t('checkboxes.accept_separator')}
          <a
            className="submit-button-collaboration-link"
            href="/collaboration-auction-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('checkboxes.collaboration_auction_agreement')}
          </a>{t('checkboxes.accept_suffix') && ` ${t('checkboxes.accept_suffix')}`}.
        </PublicFormInput>
      )}

      <ArtworkTerms open={openArtworkTerms} close={() => setOpenArtworkTerms(false)} />
    </>
  );
}
